module.exports = __webpack_public_path__ + "img/serve-bg.f429265a.png";